export default "__VITE_ASSET__C7bM1$Z9__"